import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { Box, Grid } from "@mui-wrapper";
import { ExporterApp } from "@pages/settings/export-workspace/exporter-app";
import { GetExportDataToken } from "@pages/settings/export-workspace/get-export-data-token";
import { CommonStyles } from "@styles/common-styles";
/** Allows users to get a token to export/download the workspace data */
export function ExportWorkspaceOrProjects(t0) {
  const $ = _c(15);
  const {
    entityName,
    projectIds
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mt: "24px",
      backgroundColor: "surfaces.secondary",
      borderRadius: "8px",
      padding: "50px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== entityName) {
    t2 = <Text variant="heading24" component="div" color="primary.light">Let's export your {entityName}</Text>;
    $[1] = entityName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text variant="bodyL" component="div" color="text.secondary" sx={{
      marginTop: "8px",
      paddingBottom: "32px",
      borderBottom: CommonStyles.Borders.divider
    }}>Download the code and the app. Open the app and follow the instructions to start your export.</Text>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      mt: "32px",
      alignItems: "center",
      justifyContent: {
        xs: "left",
        md: "space-between"
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      xs: 12,
      md: "auto"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== projectIds) {
    t6 = <Grid size={t5}><GetExportDataToken projectIds={projectIds} /></Grid>;
    $[6] = projectIds;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      xs: 12,
      md: "grow"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Grid size={t7}><ExporterApp direction={{
        xs: "column",
        md: "row"
      }} /></Grid>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6) {
    t9 = <Grid container={true} spacing={2} sx={t4}>{t6}{t8}</Grid>;
    $[10] = t6;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t2 || $[13] !== t9) {
    t10 = <Box data-testid="workspace-settings-export-workspace" sx={t1}>{t2}{t3}{t9}</Box>;
    $[12] = t2;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}